module.exports = "/1st/packs/jobmatch_banner_pc-e1c3fd44866f841189616bff0dd9b31d.png";